import React from 'react';
import './fold.css';

const Fold8 = () => {
  const comparisonData = [
    {
      feature: "Recovery Rate",
      aiVoice: "30–40% extra",
      emailOnly: "~15–20%",
      highlight: true
    },
    {
      feature: "Response Time",
      aiVoice: "Immediately",
      emailOnly: "1–24 hr",
      highlight: true
    },
    {
      feature: "Real-time Support",
      aiVoice: "✅",
      emailOnly: "❌",
      highlight: false
    },
    {
      feature: "Personalized Incentives",
      aiVoice: "✅",
      emailOnly: "Limited",
      highlight: false
    },
    {
      feature: "Multilingual 24/7",
      aiVoice: "✅",
      emailOnly: "✅",
      highlight: false
    }
  ];

  return (
    <div className="fold-content">
      <div className="comparison-container">
        <div className="section-header">
          <h2 className="section-title">Feature Comparison</h2>
          <p className="section-subtitle">AI Voice vs Email-only</p>
        </div>

        <div className="comparison-table-wrapper">
          <div className="comparison-table">
            <div className="table-header">
              <div className="header-cell feature-header">Feature</div>
              <div className="header-cell ai-header">AI Voice </div>
              <div className="header-cell email-header">Email-only</div>
            </div>
            
            <div className="table-body">
              {comparisonData.map((row, index) => (
                <div 
                  key={index} 
                  className={`table-row ${row.highlight ? 'highlight-row' : ''}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="table-cell feature-cell">
                    {row.feature}
                  </div>
                  <div className="table-cell ai-cell">
                    {row.aiVoice}
                  </div>
                  <div className="table-cell email-cell">
                    {row.emailOnly}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fold8;